import { Box, Container, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

const Root = styled(Box)(`
  position: relative;
  overflow-x: hidden;
  color: #fff;
`)

const stageWidth = { xs: '100%', md: 1024, lg: 1280, xl: 1680 }
const StageVolkswagen = () => {
  return (
    <Root>
      <Box
        zIndex={-1}
        width={stageWidth}
        overflowX='hidden'
        display='flex'
        justifyContent='center'
        mx='auto'
      >
        <Box
          component='img'
          width='100%'
          overflowX='hidden'
          src='/images/banners/vw/banner-bg.jpg'
          sx={{ transform: { xs: 'scaleX(-1)', xl: 'scaleX(1)' } }} // Flip the banner on smaller screens
        />
      </Box>
      <Box position='absolute' width='100%' height='100%' top={0} left={0}>
        <Box
          mx='auto'
          width={stageWidth}
          sx={{ px: { xs: 4, sm: 8, xl: 0 }, py: { xs: 4, sm: 4, md: 8 } }}
          maxWidth={1440}
        >
          <Box
            component='img'
            src='/images/banners/vw/logo.png'
            height={{ xs: 32, sm: 56, md: 80, lg: 104 }}
          />
          <Typography
            variant='h2'
            sx={{
              mt: { xs: 0.5, sm: 2 },
              ml: { xs: 0, sm: 2, lg: 4 },
              fontSize: { xs: '1.1em', sm: '2em', md: '2.5em', lg: '2.5em' },
              textShadow: '2px 2px black',
              filter: 'drop-shadow(0 0 4px #000) drop-shadow(0 0 4px #2e2e2e)',
            }}
            maxWidth='45%'
          >
            Tyre Guard
          </Typography>
        </Box>
      </Box>
    </Root>
  )
}

export default StageVolkswagen
